module.exports = __webpack_public_path__ + "82f0e9888fd24d2ca1670058a747edf0.png";